/* eslint-disable sort-keys */
import {
    HeroExclamationTriangleIcon,
    XIcon,
} from '../Icon'
import React, {useContext} from 'react'

import {
    ToastBar,
    Toaster,
    toast,
} from 'react-hot-toast'

import Button from 'components/Button'
import {ThemeContext} from 'stitches/ThemeProvider/ThemeProvider'

import {
    theme as defaultTheme,
} from 'stitches/config'
import styles from './styles/ToastView.module.scss'

const ToastView = (): React.ReactElement => {
    const theme = useContext(ThemeContext) as typeof defaultTheme

    return (
        <Toaster
            containerStyle={{zIndex: theme.zIndices?.toast?.value}} // LAYER 5: Critical - matches $toast token
            toastOptions={{
                className: styles.ToastView,
                style: {
                    backgroundColor: theme.colors?.toastBackgroundDefault?.value,
                    borderRadius: theme.radii?.toast?.value,
                    color: theme.colors?.toastTextDefault?.value,
                    font: theme.fonts?.toast?.value,
                    fontSize: theme.fontSizes?.toast?.value,
                    fontStyle: theme.fontStyle?.toast?.value,
                    fontVariant: theme.fontVariant?.toast?.value,
                    fontWeight: theme.fontWeights?.toast?.value,
                    lineHeight: theme.lineHeights?.toast?.value,
                    borderColor: theme.colors?.toastBorderDefault?.value,
                    borderStyle: theme.borderStyles?.toast?.value,
                    borderWidth: theme.borderWidths?.toast?.value,
                    padding: '6px 6px 6px 16px',
                },
                error: {
                    icon: <HeroExclamationTriangleIcon size={24} />,
                    iconTheme: {
                        primary: theme.colors?.toastBackgroundError?.value,
                        secondary: theme.colors?.toastTextError?.value,
                    },
                    style: {
                        background: theme.colors?.toastBackgroundError?.value,
                        color: theme.colors?.toastTextError?.value,
                        borderColor: theme.colors?.toastBorderSuccess?.value,
                    },
                },
                loading: {
                    iconTheme: {
                        primary: theme.colors?.toastBackgroundError?.value,
                        secondary: theme.colors?.toastTextError?.value,
                    },
                    style: {
                        background: theme.colors?.toastBackgroundError?.value,
                        color: theme.colors?.toastTextError?.value,
                        borderColor: theme.colors?.toastBorderSuccess?.value,
                    },
                },
                success: {
                    iconTheme: {
                        primary: theme.colors?.toastBackgroundSuccess?.value,
                        secondary: theme.colors?.toastTextSuccess?.value,
                    },
                    style: {
                        background: theme.colors?.toastBackgroundSuccess?.value,
                        color: theme.colors?.toastTextSuccess?.value,
                        borderColor: theme.colors?.toastBorderSuccess?.value,
                    },
                },
            }}
        >
            {(t) => (
                <ToastBar
                    style={{
                        ...t.style,
                        maxWidth: '100%',
                    }}
                    toast={t}
                >
                    {({
                        icon,
                        message,
                    }) => (
                        <>
                            {icon}
                            {message}
                            {t.type !== 'loading' &&
                            <Button color='text' iconLeft={XIcon} onPress={() => toast.dismiss(t.id)} size='small' type='button' />}
                        </>
                    )}
                </ToastBar>
            )}
        </Toaster>
    )
}

export default ToastView
